import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "m19.7753 18.6511-2.9662-2.9444a7.205 7.205 0 0 0 1.5581-5.0958 7.203 7.203 0 0 0-2.3692-4.7726 7.193 7.193 0 0 0-4.9991-1.8356 7.193 7.193 0 0 0-4.8913 2.1065 7.204 7.204 0 0 0-2.1049 4.895 7.204 7.204 0 0 0 1.8342 5.0029 7.192 7.192 0 0 0 9.8609.8117l2.9422 2.9445a.799.799 0 0 0 1.1353 0 .8006.8006 0 0 0 0-1.1122m-8.5629-1.8323a5.594 5.594 0 0 1-3.1093-.9439 5.6 5.6 0 0 1-2.0613-2.5136 5.605 5.605 0 0 1-.3185-3.2361A5.6 5.6 0 0 1 7.255 7.2575a5.595 5.595 0 0 1 2.8656-1.5329 5.593 5.593 0 0 1 3.2336.3187 5.6 5.6 0 0 1 2.5117 2.0629c.615.921.9432 2.004.9432 3.1117a5.603 5.603 0 0 1-1.6392 3.9605 5.595 5.595 0 0 1-3.9575 1.6404"
}), "Search", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
